export const salesTrendsColumns = [
  { id: "min", title: "Min quantity" },
  { id: "pack_size", title: "Pack size" },
  { id: "cost", title: "Cost" },
  { id: "price", title: "Price" },
  { id: "margin", title: "Margin" },
] as const;
